import client from "../../graphqlClient";
import { getGraphqlResult } from "../../../Utilities/Functions";
import {
  GET_CLIENT_TYPES,
  GET_CLIENT_USERS,
  GET_DOCUMENT_REQUESTS,
  GET_DOCUMENT_TYPES,
  GET_ASSOCIATIONS_FOR_DOCUMENT_REQUEST,
  CREATE_DOCUMENT_REQUEST,
} from "./graphql";
import { httpGet } from "../../Http";

const getDocumentRequests = async (entityId) => {
  const response = await client.query({
    query: GET_DOCUMENT_REQUESTS,
    variables: {
      entityId,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getDocumentRequests");
  return results;
};

const getClientTypes = async (entityId) => {
  const response = await client.query({
    query: GET_CLIENT_TYPES,
    variables: {
      entityId,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getClientTypes");
  return results;
};

const getClientUsers = async (entityId) => {
  const response = await client.query({
    query: GET_CLIENT_USERS,
    variables: {
      entityId,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getClientUsers");
  return results;
};

const getClientDocumentTypes = async (entityId) => {
  const response = await client.query({
    query: GET_DOCUMENT_TYPES,
    variables: {
      entityId,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getClientDocumentTypes");
  return results;
};

const getAssociationsForDocumentRequest = async (entityId) => {
  const response = await client.query({
    query: GET_ASSOCIATIONS_FOR_DOCUMENT_REQUEST,
    variables: {
      entityId,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(
    response,
    "getAssociationsForDocumentRequest",
  );
  return results;
};

const createDocumentRequest = async (entityId, challengeResponse, request) => {
  const response = await client.query({
    query: CREATE_DOCUMENT_REQUEST,
    variables: {
      entityId,
      challengeResponse,
      request,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "createDocumentRequest");
  return results;
};

const getCaptchaChallenge = async () => {
  const response = await httpGet("/captcha/challenge");
  return response;
};

export {
  getDocumentRequests,
  getClientTypes,
  getClientUsers,
  getClientDocumentTypes,
  getAssociationsForDocumentRequest,
  createDocumentRequest,
  getCaptchaChallenge,
};
